import React, { useRef } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import Header from '../header';
import Footer from '../footer';
import Sidebar from '../sidebar';
import Megamenu from '../megamenu';
import Mobsidebar from '../mobile-sidebar';
import Soundroom from '../../images/additional-resources/ebook-acoustics-demyst.webp';
import Commonnoise from '../../images/additional-resources/Common-Noise-Problems-3D01x.webp';
import Cadlibrary from '../../images/additional-resources/ebook-cad-revit.webp';
import minitheater1 from '../../images/Project_Images/mini-Theatre-1.webp';
import minitheater2 from '../../images/Project_Images/mini-theater-2.webp';
import minitheater3 from '../../images/Project_Images/mini-theater-3.webp';
import ScrollToTopButton from '../ScrollButton';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from 'react-slick';

function ProjectHoner() {
    const sliderRef = useRef(null);

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
    };

    const goToPrev = () => {
        sliderRef.current.slickPrev();
    };

    const goToNext = () => {
        sliderRef.current.slickNext();
    };

    return (
        <>
            <Helmet>
                <title>About Our Honer Aquantis - Mini Theatre Acoustics Project</title>
                <meta name="description" content="" />
                <meta property="og:title" content="Honer Aquantis - Mini Theatre" />
                <meta property="og:description" content="Supply and installation of acoustic door for the Mini Theatre." />
                <meta property="og:image" content="https://www.acousticalsurfaces.in/images/Project_Images/mini-Theatre-1.webp" />
                <meta property="og:locale" content="en-in" />
                <link rel="canonical" href="https://www.acousticalsurfaces.in/acoustic-projects/project-honer-aquantis" />
                <link rel="alternate" href="https://www.acousticalsurfaces.in/acoustic-projects/project-honer-aquantis" hreflang="en-in" />
                <meta name="geo.placename" content="India" />
                <meta http-equiv="content-language" content="IN" />
                <meta name="geo.region" content="india" />
            </Helmet>
            <Header />
            <section className="content">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-3 sidemenu">
                            <Sidebar />
                        </div>
                        <div className="col-sm-9 product-page nopaddding">
                            <div className="container">
                                <div className="megamenu">
                                    <Megamenu />
                                </div>
                            </div>
                            <div className="image-slider pro-content">
                                <div id="caption-slide" className="slider-container">
                                    <div className="slider">
                                        <Slider {...settings} ref={sliderRef}>
                                            <div className="slide">
                                                <img src={minitheater1} className="img-fluid" alt="minitheater1" />
                                            </div>
                                            <div className="slide">
                                                <img src={minitheater2} className="img-fluid" alt="minitheater2" />
                                            </div>
                                            <div className="slide">
                                                <img src={minitheater3} className="img-fluid" alt="minitheater3" />
                                            </div>
                                        </Slider>
                                    </div>
                                    <div className="switch" id="prev" onClick={goToPrev} style={{ backgroundColor: "transparent" }}><span>&#10094;</span></div>
                                    <div className="switch" id="next" onClick={goToNext} style={{ backgroundColor: "transparent" }}><span>&#10095;</span></div>
                                </div>
                            </div>
                            <div className="row pro-content">
                                <div className="col-sm-12 writeup">
                                    <h3>Honer Aquantis - Mini Theatre</h3>
                                    <p className="note">Location: Hyderabad</p>
                                    <p><strong>About Honer Aquantis - Mini Theatre</strong>
                                        <br />Honer Aquantis is a premium residential community located in Gopanpally, near Gachibowli, Hyderabad. Designed for comfort and convenience, it offers spacious 2, 3, and 4 BHK apartments across high-rise towers. With over 80% open space, landscaped gardens, and a large clubhouse, residents enjoy a peaceful lifestyle close to the city’s tech and business hubs.<br />
                                    </p>
                                    <p>
                                        <strong> Our Scope</strong>
                                        <br />Our scope for this project involves the supply and installation of acoustic door for the Mini Theatre. This soundproof door is designed to meet the acoustic requirements of the space, ensuring minimal sound transmission and optimal audio isolation. The installation was carried out in alignment with the project's architectural and acoustic specifications, maintaining both performance and aesthetic standards.
                                    </p>
                                    <br />
                                    <hr />
                                </div>
                            </div>
                            <div className="row resources">
                                <div className="col-xl-12 col-lg-12 col-sm-12">
                                    <h2>Additional Resources</h2>
                                </div>
                                <div className="col-xl-4 col-lg-4 col-sm-12">
                                    <h6 style={{ textAlign: "center" }}>Creating Better-Sounding Rooms</h6>
                                    <img className="hvr-grow" src={Soundroom} alt="Create Better Sounding Rooms" target="_blank" rel="noopener noreferrer" />
                                    <div className="butn"><Link to="/bs-rooms-guide">Download eBook</Link></div>
                                </div>
                                <div className="col-xl-4 col-lg-4 col-sm-12">
                                    <h6 style={{ textAlign: "center" }}>Solutions to Common Noise Problems</h6>
                                    <img className="hvr-grow" src={Commonnoise} alt="Common Noise Problems" target="_blank" rel="noopener noreferrer" />
                                    <div className="butn"><Link to="/noise-problems-guide">Download eBook</Link></div>
                                </div>
                                <div className="col-xl-4 col-lg-4 col-sm-12">
                                    <h6 style={{ textAlign: "center" }}><br />CAD, CSI, & Revit Library </h6>
                                    <img className="hvr-grow" src={Cadlibrary} alt="CAD Library" target="_blank" rel="noopener noreferrer" />
                                    <div className="butn"><Link to="/cad-library-guide">Access Product Cad Files</Link></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='mobsidebar'>
                        <div className="col-sm-12">
                            <div className="container">
                                <div className="row">
                                    <Mobsidebar />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ScrollToTopButton />
            </section>
            <Footer />
        </>
    )
}

export default ProjectHoner